import { Stack } from '@chakra-ui/react'
import { chooseLayout, chooseNavigation } from 'components/markdown/OperationLayout'
import CharlesMeta from 'components/meta/CharlesMeta'
import LandingFullLayout from 'layouts/LadingLayout'
import { FC } from 'react'

const MarkdownLayout: FC<any> = ({ meta, children }) => {
  const LayoutComponent = chooseLayout(meta)
  const NavigationComponent = chooseNavigation(meta)

  return (
    <LandingFullLayout
      showOnlineConsultationsSection={false}
      showHowItWorksSection={false}
      showMedicalTeamSection={false}
      showOmensInMediaSection={false}
      showTestimoniesSection={false}
    >
      <CharlesMeta title={meta?.title} description={meta?.description} image={meta?.shareImage} />
      <Stack maxW={1280} m="0 auto">
        <LayoutComponent data={meta} navigation={<NavigationComponent />}>
          {children}
        </LayoutComponent>
      </Stack>
    </LandingFullLayout>
  )
}

export default MarkdownLayout
